module.exports = __webpack_public_path__ + "img/bj.73700402.svg";